import {
  IdealistDayEvent as ApiIdealistDayEvent,
  deleteEvent as apiDeleteEvent,
  fetchEvent as apiFetchEvent,
  fetchGroupEvents as apiFetchGroupEvents,
  hideEvent as apiHideEvent,
  publishEvent as apiPublishEvent,
  unhideEvent as apiUnhideEvent,
} from 'api/groupAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '../..';
import { setError } from '../error';
import { pushFlashMessage } from '../flashMessages';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { clearResults } from '../mainSearch';

// Types

export type IdealistDayEvent = ApiIdealistDayEvent & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, IdealistDayEvent>;
  byGroupId: Record<
    string,
    {
      idealistDayEventIds: Array<string>;
      isFetching: boolean;
    }
  >;
};

type FetchEventRequestAction = {
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST';
  eventId: string;
};
type FetchEventSuccessAction = {
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS';
  groupId: string;
  event: ApiIdealistDayEvent;
};
type FetchGroupEventsRequestAction = {
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST';
  groupId: string;
};
type FetchGroupEventsSuccessAction = {
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS';
  groupId: string;
  events: Array<ApiIdealistDayEvent>;
};
type RemoveGroupEventAction = {
  type: 'GROUP_DASHBOARD_REMOVE_GROUP_IDEALIST_DAY_EVENT';
  groupId: string;
  eventId: string;
};
export type Action =
  | FetchEventRequestAction
  | FetchEventSuccessAction
  | FetchGroupEventsRequestAction
  | FetchGroupEventsSuccessAction
  | RemoveGroupEventAction;

// Reducer

export default function idealistDayEventsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
    byGroupId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true,
          },
        },
      };

    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      const { event, groupId } = action;
      const newState = {
        ...state,
        byId: {
          ...state.byId,
          [event.id]: { ...action.event, isFetching: false },
        },
      };
      const groupEvents = state.byGroupId[groupId];

      if (groupEvents && !groupEvents.isFetching) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line prefer-destructuring
        const idealistDayEventIds = groupEvents.idealistDayEventIds;

        if (!idealistDayEventIds.includes(event.id)) {
          newState.byGroupId[groupId].idealistDayEventIds = [
            ...idealistDayEventIds,
            event.id,
          ];
        }
      }

      return newState;
    }

    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST':
      return {
        ...state,
        byGroupId: {
          ...state.byGroupId,
          [action.groupId]: {
            ...state.byGroupId[action.groupId],
            isFetching: true,
          },
        },
      };

    case 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS': {
      const newState = { ...state };
      action.events.forEach((event) => {
        newState.byId[event.id] = { ...event, isFetching: false };
      });
      newState.byGroupId[action.groupId] = {
        idealistDayEventIds: action.events.map((e) => e.id),
        isFetching: false,
      };
      return newState;
    }

    case 'GROUP_DASHBOARD_REMOVE_GROUP_IDEALIST_DAY_EVENT': {
      const { eventId, groupId } = action;
      const eventIds = state.byGroupId[groupId].idealistDayEventIds || [];
      return {
        ...state,
        byGroupId: {
          ...state.byGroupId,
          [action.groupId]: {
            idealistDayEventIds: eventIds.filter((id) => id !== eventId),
          },
        },
      };
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchEventRequest = (eventId: string): FetchEventRequestAction => ({
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST',
  eventId,
});

const fetchEventSuccess = (
  groupId: string,
  event: ApiIdealistDayEvent
): FetchEventSuccessAction => ({
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS',
  groupId,
  event,
});

export const fetchEvent =
  ({
    eventId,
    groupId,
    force,
  }: {
    eventId: string;
    groupId: string;
    force?: boolean;
  }) =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line consistent-return
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const event = state.groupDashboard.idealistDayEvents.byId[eventId];

    if (!event || force) {
      dispatch(fetchEventRequest(eventId));
      return apiFetchEvent(groupId, eventId)
        .then((fetchedEvent) => {
          dispatch(fetchEventSuccess(groupId, fetchedEvent));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
export const updateEvent = fetchEventSuccess;
export const hideEvent =
  (eventId: string, groupId: string) => (dispatch: Dispatch) =>
    apiHideEvent(groupId, eventId)
      .then((event) => {
        dispatch(updateEvent(groupId, event));
        dispatch(clearResults());
        dispatch(
          pushFlashMessage({
            type: 'LISTING_HIDDEN',
          })
        );
      })
      .catch(setError);
export const unhideEvent =
  (eventId: string, groupId: string) => (dispatch: Dispatch) =>
    apiUnhideEvent(groupId, eventId)
      .then((event) => {
        dispatch(updateEvent(groupId, event));
        dispatch(clearResults());
        dispatch(
          pushFlashMessage({
            type: 'LISTING_UNHIDDEN',
          })
        );
      })
      .catch(setError);
export const publishEvent =
  (eventId: string, groupId: string) => (dispatch: Dispatch) =>
    apiPublishEvent(groupId, eventId)
      .then((event) => {
        dispatch(updateEvent(groupId, event));
        dispatch(clearResults());
        dispatch(
          pushFlashMessage({
            type: 'EVENT_PUBLISHED',
          })
        );
        return event;
      })
      .catch(setError);

const removeGroupEvent = (
  groupId: string,
  eventId: string
): RemoveGroupEventAction => ({
  type: 'GROUP_DASHBOARD_REMOVE_GROUP_IDEALIST_DAY_EVENT',
  groupId,
  eventId,
});

export const deleteEvent =
  (eventId: string, groupId: string) => (dispatch: Dispatch) =>
    apiDeleteEvent(groupId, eventId)
      .then((deletedEvent) => {
        dispatch(updateEvent(groupId, deletedEvent));
        dispatch(removeGroupEvent(groupId, eventId));
        dispatch(clearResults());
      })
      .catch(setError);

const fetchGroupEventsRequest = (
  groupId: string
): FetchGroupEventsRequestAction => ({
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST',
  groupId,
});

const fetchGroupEventsSuccess = (
  groupId: string,
  events: Array<ApiIdealistDayEvent>
): FetchGroupEventsSuccessAction => ({
  type: 'GROUP_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS',
  groupId,
  events,
});

export const fetchGroupEvents =
  (groupId: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const groupEvents =
      state.groupDashboard.idealistDayEvents.byGroupId[groupId];

    if (!groupEvents) {
      dispatch(fetchGroupEventsRequest(groupId));
      apiFetchGroupEvents(groupId)
        .then((fetchedEvents) => {
          dispatch(fetchGroupEventsSuccess(groupId, fetchedEvents));
        })
        .catch((error) => {
          dispatch(setError(error));
        });
    }
  };
